var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","fixed":""}},[_c('span',{staticClass:"green--text darken-2"},[_vm._v("© 2019")])])}
var staticRenderFns = []

export { render, staticRenderFns }